









































import { Constants } from '@/constants';
import { PartyModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { partiesStore } from '@/libs/parties/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

@Component({})
export default class DashboardNewClientsColumn extends Page {

    @Prop() tenantId!: string;

    get items (): PartyModel[] {
        return partiesStore.useGetter(CrudGetter.Data, "NewClients") as PartyModel[];
    }

    mounted () {
        this.load();
    }

    load () {
        partiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyModel>([ { field: "createdAt", index: 1, order: "desc" } ], [
            { field: "clientStateId", op: "eq", comparand: Constants.PartyStateInterestedId }
        ], undefined, false, "NewClients"))
    }

}
